import { downloadFile, retrieveReportTemplate } from "../../../../apis/apiExports";
import { useState, useEffect } from "react";
import Icon from "../../../Icon/Icon";
import { EGButton } from '../../../MainComponents/Button/EGButton/EGButton';
import Grid from '@mui/material/Grid2';
import Divider from '@mui/material/Divider';
import { MCTooltip } from "../../../MainComponents";
import { useTranslation } from "react-i18next";
import { parseDateToLgComun2 } from "../../../../helpers/dateTransform";
import { enqueueSnackbar } from "notistack";
import ModalInfoTitle from "./ModalInfoTitle";
import TemplateDetails from "./TemplateDetails";
import { Modal } from "react-bootstrap";
import "./DetailFileModal.scss";

const formatDates = (date) => {
  const objectDate = new Date(date);
  const day = objectDate.getDate();
  const month = objectDate.getMonth() + 1;
  const year = objectDate.getFullYear();

  return `${day}/${month}/${year}`;
};

const DetailFile = ({
  file,
  close,
  downloadFunction,
  deleteFunction,
  selectedMode,
}) => {
  const [mode, setMode] = useState(selectedMode);

  const [viewPassword, setViewPassword] = useState(false)
  const [strPassword, setStrPassword] = useState('*************************')
  const [templateInfo, setTemplateInfo] = useState({});

  const downloadFileFunc = () => downloadFunction(file);
  const deleteFile = () => setMode('delete');
  const closeModal = () => close(false);
  const changeToInfo = () => setMode('info');
  const changeToTemplate = () => setMode('template');
  const changeToComment = () => setMode('comment');
  const [t] = useTranslation("exports");

  const ButtonDownload = <EGButton
    label={t("detailModal.download_button")}
    color={'primary'}
    position={'center'}
    onClick={downloadFileFunc}
    size={'small'}
    disabled={!file.is_recent}
  />
  const ButtonDelete = <EGButton
    label={t("detailModal.delete_button")}
    color={'error'}
    position={'center'}
    onClick={deleteFile}
    size={'small'}
  />
  const ButtonConfirmDelete = <EGButton
    label={t("detailModal.confirm_button")}
    color={'error'}
    position={'center'}
    onClick={deleteFunction}
    size={'small'}
  />
  const ButtonClose = <EGButton
    label={t("detailModal.close_button")}
    color={'secondary'}
    position={'center'}
    onClick={closeModal}
    size={'small'}
  />
  const ButtonReturn = <EGButton
    label={t("detailModal.return_button")}
    color={'info'}
    position={'center'}
    onClick={changeToInfo}
    size={'small'}
  />

  const copyPasswordFile = async () => {
    const response = await downloadFile(file.alias);

    if (response !== undefined) {
      navigator.clipboard.writeText(response.data.password);
      enqueueSnackbar(t("Exports.copied"), { variant: "info" });
    }
  };

  const getPasswordFile = async () => {
    if (viewPassword) {
      setStrPassword('*************************');
    } else {
      const response = await downloadFile(file.alias);

      if (response !== undefined) {
        setStrPassword(response.data.password);
      }
    }

    setViewPassword(!viewPassword);
  };

  const previewComment = (comment, limit, message, action) => {
    if (!comment) return <>{''}</>;
    const lengthLimit = limit < 1 ? comment.length : limit;
    const commentToShow = comment.length > lengthLimit ? comment.slice(0, lengthLimit) : comment;
    const gtLimit = comment.length > lengthLimit;

    return (
      <>
        {commentToShow}{gtLimit ? '...' : ''}{gtLimit ? <span className="detail" onClick={action}>{message}</span> : ''}
      </>
    )
  };

  const datesRange = (range) => {
    try {
      const listDates = range.split(' - ')
      return `Del ${parseDateToLgComun2(listDates[0])} al ${parseDateToLgComun2(listDates[1])}`
    } catch {
      return ''
    }
  };

  useEffect(() => {
    const getTemplateInformation = async () => {
      const { data } = await retrieveReportTemplate(file.template_alias);
      setTemplateInfo({ ...data });
    };

    getTemplateInformation()
      .then(information => console.error('ok'))
      .catch(error => console.error(error));
  }, []);

  return (
    <>
      {
        (mode === 'info') ? (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <ModalInfoTitle
                title={file.template_name ? t("detailModal.template") : t("Exports.kind_of_exportable")}
                information={file.template_name ? t("detailModal.template_tooltip") : t("detailModal.exportable_file_tooltip")}
              />
                <p>
                  { 
                    file.template_name ? 
                    <>{file.template_name ?? ''}. <span className="detail" onClick={changeToTemplate}>{t("detailModal.details")}.</span></> :
                    <>{file.kind}</>}
                </p>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <ModalInfoTitle
                title={t("detailModal.created")}
                information={t("detailModal.created_tooltip")}
              />
              <p>{formatDates(file.created_at) ?? ''}</p>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <ModalInfoTitle
                title={t("detailModal.password")}
                information={t("detailModal.password_tooltip")}
              />
              <div className={'password-modal-label'}>
                <span className="text">
                  {strPassword}
                </span>
                <div className={'password-modal-buttons'}>
                  <MCTooltip position="top" text={t("detailModal.copy_pass")}>
                    <span className="password-modal-icon">
                      <Icon onClick={copyPasswordFile} size={16} name={'paperclip'} />
                    </span>
                  </MCTooltip>
                  <MCTooltip position="top" text={t("detailModal.see_pass")}>
                    <span className="password-modal-icon">
                      <Icon onClick={getPasswordFile} size={16} name={viewPassword ? 'outline_eye_slash' : 'outline_eye'} />
                    </span>
                  </MCTooltip>
                </div>
              </div>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <ModalInfoTitle
                title={t("detailModal.comment")}
                information={t("detailModal.comment_tooltip")}
              />
              <p>{previewComment(file.comment, 200, 'Ver todo.', changeToComment)}</p>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <ModalInfoTitle
                title={t("detailModal.range")}
                information={t("detailModal.range_tooltip")}
              />
              <p>{datesRange(file.range_date)}</p>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <ModalInfoTitle
                title={t("detailModal.kind")}
                information={t("detailModal.kind_tooltip")}
              />
              <p>{file.file_type ?? 'Excel'}</p>
            </Grid>
            <Divider />
            <div className="buttons">
              {ButtonDownload}
              {ButtonDelete}
              {ButtonClose}
            </div>
          </Grid>
        ) : ''
      }
      {
        (mode === 'delete') ? (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <h5>{t("detailModal.delete_title")}</h5>
              <p>{t("detailModal.delete_message")}</p>
            </Grid>
            <Divider />
            <div className="buttons">
              {ButtonReturn}
              {ButtonConfirmDelete}
              {ButtonClose}
            </div>
          </Grid>
        ) : ''
      }
      {
        (mode === 'template') ? (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TemplateDetails template={templateInfo} />
            </Grid>
            <Divider />
            <div className="buttons">
              {ButtonReturn}
              {ButtonClose}
            </div>
          </Grid>
        ) : ''
      }
      {
        (mode === 'comment') ? (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <h5>{t("detailModal.comment_title")}</h5>
              <p>{file.comment ?? ''}</p>
            </Grid>
            <Divider />
            <div className="buttons">
              {ButtonReturn}
              {ButtonClose}
            </div>
          </Grid>
        ) : ''
      }
    </>
  );
};

const DetailFileModal = ({
  showComponent,
  setShowComponent,
  downloadFunction,
  deleteFunction,
  file,
  setSelectedFile,
  selectedMode,
  setSelectedMode,
}) => {
  const [t] = useTranslation("exports");
  
  useEffect(() => {
    if (!showComponent) {
      setSelectedFile({});
      setSelectedMode('info');
    }
  }, [showComponent])

  return (
    <Modal dialogClassName="modal-auto" show={showComponent} centered onHide={setShowComponent} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{t("detailModal.title")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <DetailFile
          file={file}
          close={setShowComponent}
          downloadFunction={downloadFunction}
          deleteFunction={deleteFunction}
          selectedMode={selectedMode}
        />
      </Modal.Body>
    </Modal>
  );
};

export default DetailFileModal;